/* eslint-disable */
export default {
  noRecords: 'Viimeaikaisia tallenteita ei löytynyt.',
  inBound: 'Saapuva',
  outBound: 'Lähtevät',
  missed: 'Vastaamaton puhelu',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
